import { createAction, props } from '@ngrx/store';
import { ExportBatchApiModel } from 'app/models/export-batch-api.model';

export const createExportBatch = createAction(
  '[ExportBatches] Create',
  props<{ exportBatch: ExportBatchApiModel }>()
);

export const createExportBatchSuccess = createAction(
  '[ExportBatches] Create Successful',
  props<ExportBatchApiModel>()
);

export const createExportBatchFailed = createAction(
  '[ExportBatches] Create Failed',
  props<{ error: any }>()
);

export const updateExportBatch = createAction(
  '[ExportBatches] Update',
  props<{ exportBatch: ExportBatchApiModel }>()
);

export const updateExportBatchSuccess = createAction(
  '[ExportBatches] Update Successful'
);

export const updateExportBatchFailed = createAction(
  '[ExportBatches] Update Failed',
  props<{ error: any }>()
);

export const deleteExportBatch = createAction(
  '[ExportBatches] Delete',
  props<{ exportBatch: ExportBatchApiModel }>()
);

export const deleteExportBatchSuccess = createAction(
  '[ExportBatches] Delete Successful'
);

export const deleteExportBatchFailed = createAction(
  '[ExportBatches] Delete Failed',
  props<{ error: any }>()
);

export const deleteExportBatchesList = createAction(
  '[ExportBatches] Delete List',
  props<{ exportBatches: ExportBatchApiModel[] }>()
);

export const deleteExportBatchesListSuccess = createAction(
  '[ExportBatches] Delete List Successful'
);

export const deleteExportBatchesListFailed = createAction(
  '[ExportBatches] Delete List Failed',
  props<{ error: any }>()
);

export const exportExportBatch = createAction(
  '[ExportBatches] Export',
  props<{ exportBatch: ExportBatchApiModel }>()
);

export const exportExportBatchSuccess = createAction(
  '[ExportBatches] Export Successful'
);

export const exportExportBatchFailed = createAction(
  '[ExportBatches] Export Failed',
  props<{ error: any }>()
);

export const resetExportBatches = createAction('[ExportBatches] Reset');
